export default {
    topics: [
        {
            title: ' enumerations ',
            href: 'p-Schema-enumerations.html',
            attributes: { 'data-id': 'p-Schema-enumerations' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-enumerations-d66e5983',
            topics: [],
        },
        {
            title: ' id ',
            href: 'p-Schema-id.html',
            attributes: { 'data-id': 'p-Schema-id' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-id-d66e5991',
            topics: [],
        },
        {
            title: ' isLibrary ',
            href: 'p-Schema-isLibrary.html',
            attributes: { 'data-id': 'p-Schema-isLibrary' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-isLibrary-d66e5999',
            topics: [],
        },
        {
            title: ' labelSingular ',
            href: 'p-Schema-labelSingular.html',
            attributes: { 'data-id': 'p-Schema-labelSingular' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-labelSingular-d66e6007',
            topics: [],
        },
        {
            title: ' mappingType ',
            href: 'p-Schema-mappingType.html',
            attributes: { 'data-id': 'p-Schema-mappingType' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-mappingType-d66e6015',
            topics: [],
        },
        {
            title: ' md5 ',
            href: 'p-Schema-md5.html',
            attributes: { 'data-id': 'p-Schema-md5' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-md5-d66e6023',
            topics: [],
        },
        {
            title: ' namespace ',
            href: 'p-Schema-namespace.html',
            attributes: { 'data-id': 'p-Schema-namespace' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-namespace-d66e6031',
            topics: [],
        },
        {
            title: ' root ',
            href: 'p-Schema-root.html',
            attributes: { 'data-id': 'p-Schema-root' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-root-d66e6039',
            topics: [],
        },
        {
            title: ' toDocument ',
            href: 'm-Schema-toDocument.html',
            attributes: { 'data-id': 'm-Schema-toDocument' },
            menu: { hasChildren: false },
            tocID: 'm-Schema-toDocument-d66e6047',
            topics: [],
        },
        {
            title: ' userDescription ',
            href: 'p-Schema-userDescription.html',
            attributes: { 'data-id': 'p-Schema-userDescription' },
            menu: { hasChildren: false },
            tocID: 'p-Schema-userDescription-d66e6055',
            topics: [],
        },
    ],
};

